import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./ProductBreadcrumbs.css";
type Props = { items: string[]; };
const ProductBreadcrumbs = ({ items }: Props) => {
    const navigate = useNavigate();
    const handleClick = (index: number) => {
        if (index === 0) { navigate("/HomePage"); }
    };
    return (
        <nav className="product-breadcrumbs" aria-label="Breadcrumb">
            <div className="product-breadcrumbs-inner">
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;
                    return (
                        <div className="product-breadcrumb-item" key={`${item}-${index}`}>
                            <button type="button" className={isLast ? "active" : ""} onClick={() => handleClick(index)} disabled={isLast} > {item} </button>
                            {!isLast && (<ChevronRight size={11} strokeWidth={1.9} />)}
                        </div>
                    );
                })}
            </div>
        </nav>
    );
};
export default ProductBreadcrumbs;